import { IConsentCookie, ICookieConsentTypesResolverPayload } from "../types/shop-cookies";

export function requestCookieConsent(): Promise<IConsentCookie> {
  return new Promise((resolve, reject) => {
    const payload: ICookieConsentTypesResolverPayload = {
      resolve,
      reject
    };

    shell?.messageBroker.publishTo("ESMKT.CookieBar.CookieConsentTypesResolver", payload);
  });
}
